import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createBlock(_component_a_empty, _mergeProps({
    class: _ctx.$style['empty-data'],
    image: _ctx.simpleImage
  }, _ctx.$attrs), null, 16, ["class", "image"]))
}